import React, { useEffect } from 'react';
import { Warning } from "../../wui-core/src/index";
import AutoComplete from './AutoCompleteX';
import { AutoCompletePropsSub } from './iAutoComplete';

const { isShouldUpdate } = Warning;

const AutoCompleteWrapper: React.FC<AutoCompletePropsSub> = (props) => {
    const {
        show,
        open,
        onSelectOption,
        onSelect,
        ...others
    } = props;

    useEffect(() => {
        isShouldUpdate("AutoComplete", props);
    }, [props]);

    const extral = {
        open: open ?? show,
        onSelect: onSelect ?? onSelectOption,
    };

    return <AutoComplete {...extral} {...others} />;
};

export default AutoCompleteWrapper;